import { GetStaticProps } from 'next';

import { dehydrate } from '@tanstack/react-query';

import { getOffering } from '@arrived/api_v2';
import { offeringKeyFn } from '@arrived/queries';

import { queryClientFactory } from '../../query-client';

export interface PropertyStaticProps {
  shortName: string;
}

export const getPropertyStaticProps: GetStaticProps<PropertyStaticProps> = async (context) => {
  const queryClient = queryClientFactory();
  const foundShortName = context?.params?.shortName as string;

  const offering = await getOffering(foundShortName);

  await Promise.all([
    queryClient.prefetchQuery({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: offeringKeyFn(offering.id),
      queryFn: () => Promise.resolve(offering),
    }),
    queryClient.prefetchQuery({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: offeringKeyFn(offering.shortName),
      queryFn: () => Promise.resolve(offering),
    }),
    /**
     * Leaving the below queries commented out to ensure the payload size of the cache is smaller.
     * Once our endpoints are shrunk down, we can increase the payload size.
     */
    // offering.market &&
    //   queryClient.prefetchQuery(marketsRoiKeyFn(offering.market?.id), () => getMarketRoi(offering.market?.id)),
    // queryClient.prefetchQuery(offeringDividendKeyFn(offering.id), () => getOfferingDividends(offering.id)),
    // queryClient.prefetchQuery(offeringDocumentsKeyFn(offering.id), () => getOfferingDocuments(offering.id)),
    // queryClient.prefetchQuery(
    //   zillowPriceByZipCodeKeyFn(offering.properties[0].address?.zipCode, TWELVE_YEARS_AGO),
    //   () => getZillowPriceByZipCode(offering.properties[0].address?.zipCode, TWELVE_YEARS_AGO)
    // ),
  ]);

  return {
    props: {
      shortName: foundShortName,
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 120,
  };
};
